import Vue from 'vue';
import Router from 'vue-router';
import routers from './router';
import store from '../store';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条样式
import changTitle from '../libs/changTitle';
import { handleAxiosAndRouterToken, removeAllCookie, toLogin, validateCookieCert } from '../libs/loginUtils';

Vue.use(Router);
const RouterConfig = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routers
};
const router = new Router(RouterConfig);
// 免登录白名单
const WhiteList = ['login', '404', '403'];
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  // 在免登录白名单，直接进入
  if (WhiteList.indexOf(to.name) >= 0) {
    return next();
  }

  // 白名单之外，判断是否登录
  if (validateCookieCert()) {
    // 校验token
    await handleAxiosAndRouterToken();
  } else {
    removeAllCookie();
    toLogin();
  }
  await store.dispatch('getUser');
  await store.dispatch('GET_BTN_PERMISSIONS');
  next();
});
router.afterEach((to) => {
  // 路由跳转后
  if (to.meta.title) {
    changTitle(to.meta.title, process.env.BASE_URL);
  }
  NProgress.done(); // 结束Progress
});
export default router;
